export default __webpack_public_path__ + "static/media/innovation.2cf33036.svg";